export const getEllipsisText = (string:string, maxLength:number) => {
  if(typeof string === 'string') {
    return string.trim().length > maxLength 
    ? `${string.trim().slice(0, maxLength)}...` 
    : string.trim();
  } else {
    return ''
  }
}